import axios from "axios";
import { getLayoutWithoutData } from "Utils";

export const saveSlideComposition = ({
  uen,
  slideId,
  labels,
  isPublic,
  SlideIndicators,
  layout,
  status,
  isEditable
}) => {
  let newLayout = getLayoutWithoutData(layout);
  const requestUrl = `/data/compose/slide`;
  let formData = new FormData();
  formData.append("uen", uen);
  slideId && formData.append("slideId", slideId);
  formData.append("labels", JSON.stringify(labels));
  formData.append("isPublic", isPublic);
  formData.append("slideIndicators", JSON.stringify(SlideIndicators));
  formData.append("layout", JSON.stringify(newLayout));
  formData.append("status", status);
  formData.append("isEditable", isEditable);

  return axios.post(requestUrl, formData);
};

export const getSlide = ({ id, uen, status }) => {
  const requestUrl = `/data/slide`;

  let params = {
    id: id,
    uen: uen,
    status: status
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/slideComposition.js